import styled from "styled-components";

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 1rem; 
`;

export const Modal = styled.div`
  background-color: #fff;
  border-radius: 2px;
  width: min(90%, 46rem);
  padding: 2rem 1.5rem 1.5rem 1.5rem;
  position: relative;
  box-shadow: 0 4px 24px rgba(0,0,0,0.18);
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 768px) {
    width: 94%;
    max-width: 40rem;
    padding: 1.25rem;
    height: auto;
    overflow-y: auto;
    align-items: stretch;
  }

  @media (max-width: 420px) {
    padding: 1rem;
    border-radius: 2px;
  }

  .square {
    width: 100%;
    max-width: 57rem;

    min-width: auto;
    height: auto;
    min-height: 10rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: #E1E1E1;
    padding: 2rem;
    gap: 1.5rem;

    img {
      width: 3rem; 
      height: auto;
    }

    p {
      margin: 0 0 1rem 0;
      text-align: center;
      font-size: 1.05rem;
      color: #6E6E6E;
      padding: 0 0.5rem;
      word-break: break-word;
    }

    button {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 0.5rem;
      padding: 0.6em 1.2em;
      width: 18rem;
      max-width: 100%;
      border: 1px solid var(--blue);
      background: var(--white);
      color: var(--blue);
      font-size: 1em;
      cursor: pointer;
    }
  }

    @media (max-width: 768px) {
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 12px;
  right: 16px;
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;

  @media (max-width: 420px) {
    top: 8px;
    right: 10px;
    font-size: 1.25rem;
  }
`;

export const Title = styled.h2`
  width: 100%;
  margin: 0 0 2rem 0;
  font-size: 1.3rem;
  font-weight: 500;

  @media (max-width: 420px) {
    font-size: 1.05rem;
    margin-bottom: 1rem;
  }
`;

export const Buttons = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: flex-end;
  gap: 16px;
  margin-top: 2rem;

  @media (max-width: 420px) {
    flex-direction: column-reverse;
    gap: 8px;
    align-items: stretch;
  }
`;

export const ModalButton = styled.button`
  padding: 0.7em 2em;
  border: none;
  font-size: 1em;
  cursor: pointer;
  background: var(--white);
  color: var(--blue);
  border: 1px solid var(--blue);
  &:last-child {
    background: var(--blue);
    color: var(--white);
  }

  @media (max-width: 420px) {
    width: 100%;
    padding: 0.75em 1rem;
    font-size: 0.95rem;
  }
`;